/* NUO UI helpers shared by the custom scripts (component review, 27.09.2026). Loaded with `defer` before them.
   - NuoUI.money(cents): the shop's money format ("229,99 lei"), one formatter for every custom script;
   - NuoUI.dragToClose(panel, handles, close): the bottom-sheet gesture (drag the grip or the header down to close);
   - every theme modal / popover gets the same gesture on phones (its header carries the grip, see nuo-ui.css). */
(function () {
  var settings = (window.themeVariables && window.themeVariables.settings) || {};

  function money(cents) {
    var format = settings.moneyFormat || '{{amount_with_comma_separator}} lei';
    var value = Math.max(0, Math.round(cents || 0)) / 100;
    function group(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        default: return group(value, 2, '.', ',');
      }
    });
    // A no-break space keeps "229,99 lei" on one line.
    return out.replace(/<[^>]*>/g, '').replace(/ (?=\S+$)/, ' ');
  }

  // Drag the grip or the header of a bottom sheet down to close it (phones; a mouse drag works too).
  function dragToClose(panel, handles, close, threshold) {
    var startY = null, limit = threshold || 120;
    handles.forEach(function (el) {
      if (!el) return;
      el.style.touchAction = 'none';
      el.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button, a, input') || window.matchMedia('(min-width: 700px)').matches) return;
        el.setPointerCapture(e.pointerId);
        startY = e.clientY;
        panel.style.transition = 'none';
      });
      el.addEventListener('pointermove', function (e) {
        if (startY !== null) panel.style.transform = 'translateY(' + Math.max(0, e.clientY - startY) + 'px)';
      });
      function up(e) {
        if (startY === null) return;
        var dy = e.clientY - startY;
        startY = null;
        panel.style.transition = '';
        panel.style.transform = '';
        if (dy > limit) close();
      }
      el.addEventListener('pointerup', up);
      el.addEventListener('pointercancel', up);
    });
  }

  // Theme modals and popovers (quick buy, "Alege nuanța potrivită", sort, …): same gesture on their header, phones only.
  // Past the threshold the sheet leaves from where the finger let go, then the theme closes it as usual.
  var drag = null;
  function part(host, name) { return host.shadowRoot && host.shadowRoot.querySelector('[part~="' + name + '"]'); }
  document.addEventListener('pointerdown', function (e) {
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    var path = e.composedPath();
    var header = null, host = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1) continue;
      if (/^(BUTTON|A|INPUT|SELECT|LABEL)$/.test(n.tagName)) return;
      if (!header && n.getAttribute && /(^|\s)header(\s|$)/.test(n.getAttribute('part') || '')) header = n;
      if (header && n.shadowRoot && n.hasAttribute('open') && n.classList && (n.classList.contains('modal') || n.classList.contains('popover'))) { host = n; break; }
    }
    if (!host) return;
    var content = part(host, 'content');
    if (!content) return;
    header.setPointerCapture && header.setPointerCapture(e.pointerId);
    drag = { host: host, header: header, content: content, y: e.clientY, dy: 0 };
    content.style.transition = 'none';
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.dy = Math.max(0, e.clientY - drag.y);
    drag.content.style.transform = 'translateY(' + drag.dy + 'px)';
  }, true);
  function release() {
    if (!drag) return;
    var d = drag; drag = null;
    if (d.dy > 120) {
      var overlay = part(d.host, 'overlay');
      d.host.createLeaveAnimationControls = function () {
        var a = d.content.animate([{ transform: 'translateY(' + d.dy + 'px)' }, { transform: 'translateY(100%)' }], { duration: 220, easing: 'ease-in', fill: 'forwards' });
        var o = overlay ? overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 220, fill: 'forwards' }) : null;
        return { finished: Promise.all([a.finished, o ? o.finished : null]).then(function () {
          a.cancel(); if (o) o.cancel();
          d.content.style.transition = ''; d.content.style.transform = '';
          delete d.host.createLeaveAnimationControls;
        }) };
      };
      d.host.hide();
    } else {
      d.content.style.transition = 'transform .2s ease';
      d.content.style.transform = '';
      setTimeout(function () { d.content.style.transition = ''; }, 220);
    }
  }
  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);

  window.NuoUI = { money: money, dragToClose: dragToClose };
})();
